export default "__VITE_ASSET__075b268f__"